<template>
  <div class="tarifarios-crud-wrapper">
    <!-- SECCIÓN: Familias de Tarifas -->
    <div class="familias-section mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
        <div class="d-flex align-items-center mb-1">
          <div>
            <h3 class="m-0 font-weight-bold">Segmentos</h3>
            <span class="text-muted small">Clasificación de grupos tarifarios ({{ segmentosReserva.length }})</span>
          </div>
        </div>
        <div class="d-flex align-items-center mb-1">
          <v-btn v-if="selectedSegmentoId" class="my-2 mt-2 px-2 py-1" small outlined color="secondary"
            @click="selectedSegmentoId = null">
            <i class="lni lni-close mr-1"></i> Quitar filtro
          </v-btn>
          <v-btn class="mx-4 mt-2" small outlined color="primary" @click="openSegmentoModal()">
            <i class="lni lni-plus mr-1"></i> Nuevo Segmento
          </v-btn>
        </div>
      </div>

      <!-- Grid Compacto de Familias -->
      <div class="familias-compact-grid">
        <div v-for="segmento in segmentosReserva" :key="segmento.id" class="familia-chip"
          :class="{ 'chip-selected': selectedSegmentoId === segmento.id, 'chip-inactive': !segmento.activo }"
          :style="{ '--accent-color': segmento.color || '#dceeff' }" @click="toggleSegmentoSelection(segmento.id)">
          <!-- Barra lateral de color -->

          <div class="chip-body">
            <!-- Fila superior: Código y Acciones -->
            <div class="chip-top">
              <span class="chip-code">
                {{ segmento.nm }}
              </span>

              <div class="chip-actions" @click.stop>
                <button class="btn-icon edit" @click.stop="openSegmentoModal(segmento)" title="Editar Segmento">
                  <i class="lni lni-pencil-alt"></i>
                </button>
                <button class="btn-icon delete" @click.stop="deleteSegmentoReserva(segmento.id)"
                  title="Eliminar Segmento">
                  <i class="lni lni-trash"></i>
                </button>
              </div>
            </div>

            <!-- Nombre de la familia -->
            <div class="chip-title" :title="segmento.nombre">
              {{ segmento.nombre }}
            </div>

            <!-- Fila inferior: Contador y Estado -->
            <div class="chip-footer">
              <span class="chip-count" :title="`${getTarifariosCount(segmento)} tarifario(s) asignado(s)`">
                <i class="lni lni-layers text-muted mr-1"></i>
                <strong>{{ getTarifariosCount(segmento) }}</strong>
                <span class="ml-1 text-muted" style="font-size: 0.7rem;">
                  {{ getTarifariosCount(segmento) === 1 ? 'tarifario' : 'tarifarios' }}
                </span>
              </span>
              <span class="chip-status-dot" :class="segmento.activo ? 'active' : 'inactive'"
                :title="segmento.activo ? 'Segmento Activo' : 'Segmento Inactivo'"></span>
            </div>
          </div>
        </div>

        <!-- Tarjeta Rápida "+ Añadir" -->
        <div class="familia-chip chip-add" @click="openSegmentoModal()" title="Agregar nueva familia">
          <i class="lni lni-plus"></i>
          <span>Añadir</span>
        </div>
      </div>
    </div>

    <!-- SECCIÓN: Tarifarios -->
    <div class="tarifarios-section pt-2">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h3 class="m-0 font-weight-bold">Tarifarios</h3>
        <span v-if="selectedSegmento" class="badge badge-info p-2 font-weight-normal shadow-sm">
          <i class="lni lni-funnel mr-1"></i> Filtrando por: <strong>{{ selectedSegmento.nombre }}</strong>
        </span>
      </div>
      <DataTable :config="config" :data="displayedTarifarios" :pageRows="15" @buttonClick="dtButtonClick">
      </DataTable>
    </div>

    <!-- Modal Formulario de Familia de Tarifas -->
    <modal v-model="showSegmentoModal" :disableScroll="true" :showFooter="false"
      :title="isEditSegmento ? 'Editar Segmento de Tarifas' : 'Nuevo Segmento de Tarifas'">
      <tarifarioFamiliaForm :key="segmentoFormIndex" :show="showSegmentoModal" :edit="isEditSegmento"
        :dataEdit="segmentoEditData" @toggle="toggleSegmentoModal" @reload="getSegmentosReserva"></tarifarioFamiliaForm>
    </modal>

    <!-- Modal Formulario de Tarifario (Existente) -->
    <modal v-model="showModal" :disableScroll="true" :showFooter="false" title="Agregar Tarifarios">
      <tarifarioForm :dataEdit="editData" :edit="editMode" :key="formIndex" :show="showAddForm" @toggle="toggleModal"
        @successData="getSuccessData" :accessArray="accessArray"></tarifarioForm>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TarifasClass from "../../../clases/Tarifa.js";
import DataTable from "../../MainComponents/DataTable.vue";
import tarifarioForm from "./tarifarioForm.vue";
import tarifarioFamiliaForm from "./tarifarioFamiliaForm.vue";

export default {
  name: "TarifariosCRUD",
  components: {
    DataTable,
    tarifarioForm,
    tarifarioFamiliaForm,
  },
  data() {
    return {
      MainDepartamento: "",
      tarifarios: [],
      subcategorias: [],
      hoteles: [],
      tarifaType: "",

      formIndex: 1,
      showModal: false,
      showAddForm: false,
      editData: [],
      editMode: false,

      // --- ESTADOS Y MOCK DE FAMILIAS DE TARIFAS ---
      selectedSegmentoId: null,
      showSegmentoModal: false,
      isEditSegmento: false,
      segmentoEditData: {},
      segmentoFormIndex: 1,

      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Tarifarios",
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addTarifario",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editTarifario",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteTarifario",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Familia",
            value: "Familia",
            format: (value) => {
              let familiaId = (value.Familia) ? value.Familia : "-";
              let list = this.segmentosReserva.filter((item) => item.id === familiaId);
              return list.length > 0 ? list[0].nm : "-";
            }
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions("SegmentosReserva", ["getSegmentosReserva"]),
    deleteSegmentoReserva(id) {
      const deletedObject = (this.segmentosReserva || []).find((f) => f.id === id) || { id: id };
      const nombreSegmento = deletedObject.Nombre || deletedObject.nombre || deletedObject.nm || id;
      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "Segmento de tarifa",
        route: "RVA-SegmentosReserva-deleteSegmentoReserva",
        data: { id: id },
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "DELETE_SEGMENTO_RESERVA",
            Mensaje: `Eliminacion de segmento de tarifa ` + nombreSegmento,
            reference: { id: id, tp: "SEGMENTO_RESERVA", al: nombreSegmento },
            data: deletedObject,
          });
          this.getSegmentosReserva();
          this.$emit("reload");
        },
      });
    },
    // --- GESTIÓN DE FAMILIAS DE TARIFAS ---
    openSegmentoModal(segmento = null) {
      this.segmentoFormIndex++;
      if (segmento) {
        this.isEditSegmento = true;
        this.segmentoEditData = { ...segmento };
      } else {
        this.isEditSegmento = false;
        this.segmentoEditData = {};
      }
      this.showSegmentoModal = true;
    },

    toggleSegmentoModal(open) {
      this.showSegmentoModal = open;
    },




    toggleSegmentoSelection(segmentoId) {
      if (this.selectedSegmentoId === segmentoId) {
        this.selectedSegmentoId = null;
      } else {
        this.selectedSegmentoId = segmentoId;
      }
    },

    // --- MÉTODOS EXISTENTES DE TARIFARIOS ---
    async getTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo(
        this.MainDepartamento
      );
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },

    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Mayoristas/Coleccion"
        );
      let arrayHoteles = Object.entries(data.val());
      arrayHoteles.forEach((element) => {
        this.hoteles.push({ id: element[0], ...element[1] });
      });
    },

    showForm() {
      this.formIndex++;
      this.editMode = false;
      this.editData = {};
      this.showModal = true;
      this.showAddForm = true;
      console.log("showForm");
    },
    showEditForm(id) {
      this.formIndex++;
      this.editMode = true;
      this.editData = this.$pgsHelper.getById(this.tarifarios, "Id", id);
      this.showModal = true;
      this.showAddForm = true;
    },
    toggleModal(open) {
      this.showModal = open;
    },
    getSuccessData(data) {
      const { Id, Nombre, Familia, Segmento, Mercado, aplicableAll, accesso = [] } = data;

      const Accesos = aplicableAll
        ? { All: true }
        : Object.fromEntries((accesso || []).map((key) => [key, true]));

      const dataTarifa = {
        Nombre,
        Familia: Segmento || Familia || "",
        Segmento: Segmento || Familia || "",
        Mercado: Mercado || "",
        Accesos,
        Activo: true,
      };

      if (Id) {
        this.editTarifario({ ...dataTarifa, Id });
      } else {
        this.saveTarifario(dataTarifa);
      }
    },

    saveTarifario(data) {
      this.$pgsHelper.log(data);
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas guardar este tarifario?",
        text: "La tarifa se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifarios-createTarifario", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Tarifario Guardado",
              "El tarifario se almaceno correctamente",
              "success"
            );
            // recarga el listado de tarifarios
            this.getTarifarios();
            // limpiar el formulario y ocultar el modal
            this.showModal = false;
            this.formKey++;
            // marcar tarifa creada como sellecionado
            this.tarifaType = result.value.data.data.Id;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editTarifario(data) {
      this.$pgsHelper.log(data);
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas guardar este tarifario?",
        text: "La tarifa se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifarios-updateTarifario", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Tarifario Guardado",
              "El tarifario se almaceno correctamente",
              "success"
            );
            // recarga el listado de tarifarios
            this.getTarifarios();
            // limpiar el formulario y ocultar el modal
            this.showModal = false;
            this.formKey++;
            // marcar tarifa creada como sellecionado
            //this.tarifaType = result.value.data.data.Id;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteTarifario(ID) {
      if (ID != "WEB" && ID != "GLOBAL") {
        let data = { Id: ID, force: true };
        data.Departamento = this.MainDepartamento;

        this.$swal({
          title: "¿Deseas eliminar este Tarifario?",
          text: "Se eliminará su información permanentemente",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Eliminar",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            return await this.$store.getters.getFirebaseApp.fba
              .call("RVA-Tarifarios-deleteTarifario", data)
              .then((result) => {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              this.$swal(
                "Tarifario elimanda",
                "la tarifa se elimino correctamente",
                "success"
              );
              this.$emit("changeIndex");
              this.getTarifarios();
            } else {
              this.$swal(
                "Error al guardar los datos",
                "No se guardaron los datos",
                "error"
              );
            }
          }
        });
      } else {
        this.$swal(
          "Error al guardar los datos",
          "No se puede eliminar el tarifario " + ID,
          "error"
        );
      }
    },

    getTarifariosCount(segmento) {
      if (!segmento) return 0;
      const countById = this.tarifariosPorSegmento[segmento.id] || 0;
      const countByNm =
        segmento.nm && segmento.nm !== segmento.id
          ? this.tarifariosPorSegmento[segmento.nm] || 0
          : 0;
      return countById + countByNm;
    },

    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addTarifario") {
        console.log("button");
        this.showForm();
      }
      if (buttonId == "deleteTarifario") {
        console.log("delete");
        this.deleteTarifario(idSelected[0]);
      }
      if (buttonId == "editTarifario") {
        console.log("edit");
        this.showEditForm(idSelected[0]);
      }
    },
  },
  computed: {
    ...mapGetters("SegmentosReserva", {
      segmentosReserva: "getSegmentosReserva",
    }),
    selectedSegmento() {
      return this.segmentosReserva.find((f) => f.id === this.selectedSegmentoId) || null;
    },
    tarifariosPorSegmento() {
      const counts = {};
      if (Array.isArray(this.tarifarios)) {
        this.tarifarios.forEach((t) => {
          if (t && t.Familia) {
            counts[t.Familia] = (counts[t.Familia] || 0) + 1;
          }
        });
      }
      return counts;
    },
    displayedTarifarios() {
      if (!this.selectedSegmentoId) return this.tarifarios;
      return this.tarifarios.filter(
        (t) =>
          t &&
          (t.Segmento === this.selectedSegmentoId ||
            (this.selectedSegmento && t.Segmento === this.selectedSegmento.nm))
      );
    },
    accessArray() {
      let access = [
        {
          name: "Campo de golf",
          id: "SELF",
          key: "SELF",
          text: "Campo de golf",
          value: "SELF",
        },
      ];

      this.hoteles.forEach((element) => {
        access.push({
          code: element.Codigo,
          name: element.Nombre,
          id: element.id,
          key: element.id,
          text: element.Nombre,
          value: element.id,
        });
      });

      return access;
    },
  },
  mounted() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getTarifarios();
    this.getHoteles();
    this.getSegmentosReserva();
  },
};
</script>

<style scoped>
.familias-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.tarifarios-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* Grid de alta densidad para familias */
.familias-compact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  gap: 0.65rem;
  align-items: stretch;
}

/* Tarjeta / Chip compacta */
.familia-chip {
  position: relative;
  display: flex;
  background: #dceeff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.familia-chip:hover {
  transform: translateY(-2px);
  border-color: #cbd5e1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.07);
}

.familia-chip.chip-selected {
  border-color: var(--accent-color, #2563eb);
  background: #dceeff;
  box-shadow: 0 0 0 2px var(--accent-color, #2563eb);
}

.familia-chip.chip-inactive {
  opacity: 0.65;
  background: #dceeff;
}

/* Barra de color lateral delgada */
.chip-color-bar {
  width: 4px;
  flex-shrink: 0;
}

.chip-body {
  padding: 0.55rem 0.65rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
}

/* Cabecera compacta */
.chip-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.chip-code {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.chip-actions {
  display: flex;
  gap: 2px;
  opacity: 0.9;
  transition: opacity 0.15s ease-in-out;
}

.familia-chip:hover .chip-actions {
  opacity: 1;
}

.btn-icon {
  background: none;
  border: none;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  transition: all 0.15s;
}

.btn-icon.edit {
  color: #2563eb;
  background: #eff6ff;
}

.btn-icon.delete {
  color: #dc2626;
  background: #fef2f2;
}

/* Título */
.chip-title {
  font-size: 0.82rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.35rem;
}

/* Pie */
.chip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.72rem;
  color: #64748b;
}

.chip-count {
  display: flex;
  align-items: center;
}

.chip-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.chip-status-dot.active {
  background-color: #10b981;
  box-shadow: 0 0 0 2px #d1fae5;
}

.chip-status-dot.inactive {
  background-color: #94a3b8;
}

/* Botón rápido "+ Añadir" en grid */
.chip-add {
  border: 1px dashed #cbd5e1;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 600;
  min-height: 72px;
  gap: 4px;
}

.chip-add i {
  font-size: 1rem;
}

.chip-add:hover {
  border-color: #2563eb;
  color: #2563eb;
  background: #eff6ff;
}
</style>
